import { envs } from "application/envHandler";
import apiClient from 'core/api';
import { AxiosConfigManagementLogResponse, ConfigManagementUploadLogFilter } from "./types";

// the datepicker hands over local 'YYYY-MM-DD HH:mm:ss', the API expects ISO 8601 with offset
function toUtc(value?: string) {
  return value ? new Date(value).toISOString() : undefined
}

function toQueryParams(filter: ConfigManagementUploadLogFilter = {}) {
  const { createdDateFrom, createdDateTo, ...rest } = filter
  const params: ConfigManagementUploadLogFilter = {
    createdDateFrom: toUtc(createdDateFrom),
    createdDateTo: toUtc(createdDateTo),
  }

  for (const key in rest) {
    const castKey = key as keyof typeof rest
    if (rest[castKey]) {
      params[castKey] = rest[castKey]
    }
  }

  return params
}

export async function fetchData(filter: ConfigManagementUploadLogFilter, page: number, pageSize: number) {
  return apiClient.get('/rtf/audit', {
    baseURL: envs.REACT_APP_API_URL,
    params: {
      ...toQueryParams(filter),
      pageNumber: page - 1,
      pageSize,
    },
  }) as Promise<AxiosConfigManagementLogResponse>
}
